<template>
  <div>
    <h1>Mapa de localización</h1>
    <FirebaseTravelMap/>
  </div>
</template>
<script>
import FirebaseTravelMap from '../../../components/maps/travelMap/FirebaseTravelMap'
export default {
  name: 'Maps',
  components: {
    FirebaseTravelMap,
  },
}
</script>
